<template>
<div>
            <b-select
              :options="selectorOptions"
              v-model="selected"
              @change.native="change()"
            >
            </b-select>
</div>
</template>
<script>
import { axiosCall } from "../axiosCall";
import { cloneDeep } from "lodash";

export default {
  name: "IndicaSelector",
  props: {
    tableName: {
      type: String,
      default: null,
    },
    showTableOptions: {
      type: Boolean,
      default: true,
    },
    saveToStore: {
      type: Boolean,
      default: false,
    },
    storeName: {
      type: String,
      default: null,
    },
    storeIndex: {
      type: Number,
      default: -1,
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
    filterByField: {
      type: String,
      default: null,
    },
    filterByValue: {
      type: String,
      default: null,
    },
    otherOptions: {
      type: Array,
      default: ()=>[],
    },
  },
  data() {
    return {
      allDataArray: [],
      selectorOptions: [],
      selected: null
    };
  },
  watch: {
    storeIndex: function () {
      this.getStoreData();
    },
    saveToStore: function () {
      this.getStoreData();
    },
    otherOptions:function(){
      this.setSelectorOptions()
    }
  },
  mounted() {
    this.getStoreData();
    this.setSelectorOptions()
  },
  methods: {
    setSelectorOptions(){
      this.selectorOptions = [...this.otherOptions,...(this.showTableOptions ?  this.allDataArray:[])].map((option)=>({text:option.name, value:option}))
    },
    clearStorageAndRefresh(){
      if(this.saveToStore){
        const payload = {};
        payload["data"] = {};
        payload["storeName"] = this.storeName;
        payload["storeIndex"] = this.storeIndex;
        payload["data"]["selected"] = [];
        this.$store.dispatch("setStoreInfo", payload);
        this.$emit("change-selection");
      }
      this.refreshData()
    },
    change() {
      const payload = {};
      payload["data"] = {};
      payload["storeName"] = this.storeName;
      payload["storeIndex"] = this.storeIndex;
      payload["data"]["selected"] = [
        this.selected
      ];
      this.$store.dispatch("setStoreInfo", payload);
      this.$emit("change-selection");
    },
    refreshData: async function () {
      this.getStoreData();
    },
    getStoreData() {
      if (this.saveToStore === true && this.storeName) {
        const _ = require("lodash");
        let storeInfo = _.cloneDeep(
          this.$store.getters.getStoreInfo(this.storeName)
        );
        if (storeInfo) {
          if (this.storeIndex !== -1) {
            storeInfo = storeInfo[this.storeIndex];
          }
        }
        if (storeInfo) {
          if (storeInfo && storeInfo.selected && storeInfo.selected.length) {
           this.selected = storeInfo.selected[0]
          }
        }
      }
      if(!this.selected && this.selectorOptions[this.initialIndex]){
        this.selected = this.selectorOptions[this.initialIndex]
      }
      console.log(this.selected,this.selectorOptions,this.initialIndex)
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
